import {Box, Colors} from '@dagster-io/ui-components';
import {Props as BoxProps} from '@dagster-io/ui-components/lib/components/Box';
import clsx from 'clsx';
import {CSSProperties, ReactNode} from 'react';

import styles from '@/components/css/Card.module.css';

interface Props extends BoxProps {
  children?: ReactNode;
  responsive?: boolean;
  className?: string;
  style?: CSSProperties;
}

export default function Card({children, responsive = false, className, ...rest}: Props) {
  return (
    <Box
      className={clsx(className, styles.card, responsive && styles.responsiveCard)}
      padding={24}
      background={Colors.backgroundDefault()}
      {...rest}
    >
      {children}
    </Box>
  );
}
